define(function(require, exports, module) {
    'use strict';
    var $ = require('j');

    require('common/jbone.widget');

    module.exports = $.widget('ticker', {

        /**
         * Options by default
         * @type {Object}
         */
        options: {
            /**
             * Add string to the begining of an existing content
             * @type {String}
             */
            prefix: '',

            /**
             * Add string to the end of an existing content
             * @type {String}
             */
            suffix: '',

            /**
             * Interval for update content
             * @type {Number}
             */
            interval: 100,

            /**
             * Number of steps per unit time
             * @type {Number}
             */
            step: 1,

            /**
             * Base amount number for start
             * @type {Number}
             */
            amount: 0,

            /**
             * Is Guaranteed Hit Time enable in admin
             * @type {Boolean}
             */
            showGuaranteedHitTime: false,

            /**
             * Use to switch view
             * @type {Boolean}
             */
            isDrawHitTime: false
        },

        init: function() {
            this.option({
                time: Date.now()
            });

            this.setHitTime(this.options);
            this.render();
        },

        setHitTime: function(options) {
            const milliseconds = 1000;
            const hitTime = options.guaranteedHitTime;

            if (hitTime) {
                options.hitTime = new Date(hitTime * milliseconds).getTime() - Date.now();
            }
        },

        render: function() {
            var options = this.options;
            var span = document.createElement('span');

            span.classList.add('fn-ticker');

            this.$el.append(span);
            this.tickerEl = span;

            if (options.amount === undefined) {
                this._drawEmpty();
            } else {
                this._animate();

                this.setupHitTimeInterval();

                this.handleAnimationFrame();
            }

            return this;
        },

        setupHitTimeInterval: function() {
            if (isNaN(this.options.hitTime) || !this.options.showGuaranteedHitTime) {
                return;
            }

            this.changeValueInterval = setInterval(() => {
                this.options.isDrawHitTime = !this.options.isDrawHitTime;
            }, 5000);

            this.hitTimeInterval = setInterval(() => {
                this.options.hitTime -= 1000;
            }, 1000);
        },

        handleAnimationFrame: function() {
            this._interval = window.requestAnimationFrame(this.frameHandler.bind(this));
        },

        frameHandler: function frameHandler() {
            var options = this.options;

            if (options.originAmount <= options.amount && this.options.hitTime < 1000) {
                this.drawOriginalTickerValue();
                this.pause();

                return;
            } else if (Date.now() - options.time >= options.interval) {
                this._animate();
            }

            this.handleAnimationFrame();
        },

        pause: function() {
            if (this._interval) {
                this.clearIntervals();
                this._interval = null;
            }
        },

        resume: function() {
            if (!this._interval && this.option('amount') !== undefined) {

                this.handleAnimationFrame();
            }
        },

        _animate: function() {
            let value;

            if (this.options.originAmount <= this.options.amount) {
                this.options.amount = this.options.originAmount;

                value = this._getFormattedData();
            } else {
                value = this.drawTicker();
            }

            value = isNaN(this.options.hitTime) || this.options.hitTime < 1000
                ? value
                : this.drawHitTime(value);

            this.tickerEl.textContent = value;
        },

        drawTicker: function() {
            var options = this.options;
            var newTime = Date.now();
            var timeDiff = newTime - options.time || 0;

            options.time = newTime;
            options.amount += timeDiff / options.interval * options.step || 0;

            return this._getFormattedData(options);
        },

        drawOriginalTickerValue: function() {
            var options = this.options;

            options.amount = options.originAmount;

            this.tickerEl.textContent = this._getFormattedData(options);
        },

        drawHitTime: function(value) {
            var options = this.options;

            return options.isDrawHitTime ? this.getTime(options.hitTime) : value;
        },

        getTime: function(milliseconds) {
            var date = new Date(milliseconds);
            var daysInHours = (date.getDate() - 1) * 24; // convert day to hours

            var parseValue = function(value) {
                value = String(value);
                return value.length > 1 ? value : '0' + value;
            };

            const h = parseValue(daysInHours + date.getUTCHours());
            const m = parseValue(date.getUTCMinutes());
            const s = parseValue(date.getUTCSeconds());

            return h + ':' + m + ':' + s;
        },

        _drawEmpty: function() {
            this.tickerEl.textContent = '-';
        },

        _getFormattedData: function(options) {
            var opt = options || this.options;
            var amount = window.Playtech.API.formatter.formatCurrency(opt.amount, {
                currencyCode: opt.currencyCode
            });
            return opt.prefix + amount + opt.suffix;
        },

        intervalHandler: function() { // deprecated, method has left for old browsers
            this.options.originAmount <= this.options.amount ? this.pause() : this._animate();
        },

        clearIntervals: function() {
            window.cancelAnimationFrame(this._interval);
            window.clearInterval(this.changeValueInterval);
            window.clearInterval(this.hitTimeInterval);
        },

        /**
         * Destroy the widget
         */
        destroy: function() {
            var ticker = this.tickerEl;
            this.clearIntervals();

            ticker.parentNode && ticker.parentNode.removeChild(ticker);

            $.Widget.prototype.destroy.call(this);
        }
    });
});
